import React, { Component } from 'react';
import { connect } from 'react-redux';
import UserInfo from '../../shared/UserInfo/UserInfo';
import { Toast } from 'primereact/toast';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@material-ui/core';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { DROPDOWN_CONFIG } from '../../shared/Config';
import { Button } from 'primereact/button';
import * as actions from '../../store/actions/index';
import { Link } from 'react-router-dom';
import Messages from '../../shared/UI/Messages/Messages';
import moment from 'moment';
import './styles.css';

class ViewTimeSheet extends Component {

    constructor(props) {
        super(props);
        this.state = {
            submitData: {},
            elements: ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''],
            error: false
        }
    }

    handlechange(e) {
        e.preventDefault();
        const { name, value } = e.target;
        this.setState({ submitData: Object.assign({}, { ...this.state.submitData }, { [name]: value }) });
    }

    submit() {
        const { submitData = {} } = this.state;
        const { FromDate, ToDate } = submitData;
        let start = moment(FromDate);
        let end = moment(ToDate);
        if (FromDate && ToDate && start <= end) { 
        this.props.getEmployeeWorkSheetData(this.state.submitData);
        } else {
            this.growl.show({ severity: 'error', summary: null, detail: 'please provide correct details' });
        }
    }

    componentDidMount() {
        const { fetchSubordinatesLists, loggedUserDetail } = this.props;
        fetchSubordinatesLists(loggedUserDetail.empID, loggedUserDetail.CompanyId);//Fetch subordinate api list
    }

    componentWillUnmount() {
        const { clearCacheStorage } = this.props;
        clearCacheStorage('request', { subordinatesListData: [], employeeWorkSheetData:{} })
    }
    
    render() {

        const { subordinatesList, employeeWorkSheetData = {} } = this.props;
        const { Table: EmpData, Table1 = [] } = employeeWorkSheetData;
        const { submitData = {}, elements } = this.state;
        const { EmployeeId, fromDate, toDate } = submitData;
        const pageType = this.props.match.params.type;
    
        const View = Table1.concat(elements.slice(0, elements.length - Table1.length));
        const Header = EmpData && EmpData.length > 0 && EmpData[0];
        const { EMPLOYEE_NO, EmployeeName, POSITION, DEPARTMENT, EMPLOYEETYPE, Month1, Years, WorkingHours, OTHours, otph } = Header || {};
        return (
            <div className="p-grid leaverequest">
                <Toast ref={(el) => this.growl = el} />
                {this.props.loading && <div className="page-loader"></div>}
                {this.props.error && <Messages type="error" message={this.props.error} />}
                <div className="p-col-12">

                    <div className="card card-w-title" style={{ position: 'relative' }}>

                        <h1>TimeSheet</h1>
                        <Link to="/timesheet" style={{ position: 'absolute', right: '13px', top: '9px' }}>
                            <Button label="Back" icon="pi pi-arrow-left" className="ml1 p-button-secondary" />
                        </Link>

                        <UserInfo userObject={this.props.userPosInfo} />

                        <div className="p-col-12">

                            <div className="p-grid">

                                <div className="p-col-12 p-md-3 p-lg-3">

                                    <label className="label">
                                        Employees
                                        <span className="requiredColor">*</span>
                                    </label>

                                    <div className="mt1">
                                    <Dropdown
                                        placeholder={'Select Employees'}
                                        options={subordinatesList}
                                        value={EmployeeId}
                                        name={"EmployeeId"}
                                        onChange={this.handlechange.bind(this)}
                                        filter={true}
                                        autoWidth={true}
                                        className="p-col-12"
                                        {...DROPDOWN_CONFIG}
                                    /></div>
                                </div>
                                <div className="p-col-12 p-md-3 p-lg-3">
                                    <label>
                                        From Date
                                        <span className="requiredColor">*</span>
                                    </label>
                                    
                                    <div className="mt1">
                                    <Calendar
                                        placeholder={"From Date"}
                                        value={fromDate && new Date(fromDate) || ''}
                                        name={"FromDate"}
                                        onChange={this.handlechange.bind(this)} />
                                        </div>
                                </div>
                                <div className="p-col-12 p-md-3 p-lg-3">
                                    <label>
                                        To Date
                                        <span className="requiredColor">*</span>
                                    </label>
                                    <div className="mt1">
                                    <Calendar
                                        placeholder={"To Date"}
                                        value={toDate && new Date(toDate) || ''}
                                        name={"ToDate"}
                                        onChange={this.handlechange.bind(this)} />
                                        </div>
                                </div>
                                <div className="p-col-12 p-md-3 p-lg-3">
                                    <Button onClick={this.submit.bind(this)} className="ml1" style={{ marginTop: '18px' }} label="View" icon="pi pi-save" />
                                </div>
                            </div>
                        </div>
                        {Table1 && Table1.length > 0 ? <div className="mt2">
                            <TableContainer component={Paper}>
                                <Table aria-label="spanning table" id="table-to-xls">
                                    <TableHead className="timesheetHeader">
                                        <TableRow style={{ backgroundColor: '#bebcbc' }}>
                                            <TableCell align="center">SNo</TableCell>
                                            <TableCell align="center">Emp No</TableCell>
                                            <TableCell align="center" colspan="8">Name</TableCell>
                                            <TableCell align="center" colspan="9">Position</TableCell>
                                            <TableCell align="center" colspan="9">Department</TableCell>
                                            <TableCell align="center" colspan="4">Employee Type</TableCell>
                                            <TableCell align="center" colspan="2">Month</TableCell>
                                            <TableCell align="center" colspan="2">Year</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody className="timesheetBody">
                                        <TableRow>
                                            <TableCell align="center">{EMPLOYEE_NO && '1' || null}</TableCell>
                                            <TableCell align="center">{EMPLOYEE_NO}</TableCell>
                                            <TableCell align="center" colspan="8">{EmployeeName}</TableCell>
                                            <TableCell align="center" colspan="9">{POSITION}</TableCell>
                                            <TableCell align="center" colspan="9">{DEPARTMENT}</TableCell>
                                            <TableCell align="center" colspan="4">{EMPLOYEETYPE}</TableCell>
                                            <TableCell align="center" colspan="2">{Month1}</TableCell>
                                            <TableCell align="center" colspan="2">{Years}</TableCell>
                                        </TableRow>
                                    </TableBody>
                                    <TableHead className="timesheetHeader">
                                        <TableRow style={{ backgroundColor: '#a1a1a1' }}>
                                            <TableCell align="center" colspan="34">{Month1}</TableCell>
                                            <TableCell align="center" colspan="2">Overtime</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableHead className="timesheetHeader">
                                        <TableRow style={{ backgroundColor: '#cac9c9' }}>
                                            <TableCell colspan="2">&nbsp;</TableCell>
                                            {View.map((el, index) => <TableCell key={index} align="center">{el.ShiftDate && moment(el.ShiftDate).format('DD') || null}</TableCell>)}
                                            <TableCell align="center">Total</TableCell>
                                            <TableCell align="center">Pre-Approval</TableCell>
                                            <TableCell align="center">TA Report</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody className="timesheetBody1">
                                        <TableRow>
                                            <TableCell align="center" colspan="2" style={{ background: 'darkblue', color: '#fff' }}>Shift</TableCell>
                                            {View.map((fe, index) => <TableCell key={index} align="center">{fe.ShiftName}</TableCell>)}
                                            <TableCell align="center"></TableCell>
                                            <TableCell align="center"></TableCell>
                                            <TableCell align="center"></TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell align="center" colspan="2" style={{ fontWeight: 'bold' }}>Working Hours</TableCell>
                                            {View.map((se, index) => <TableCell key={index} align="center">{se.WorkingHours}</TableCell>)}
                                            <TableCell align="center">{WorkingHours || ''}</TableCell>
                                            <TableCell align="center"></TableCell>
                                            <TableCell align="center"></TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell align="center" colspan="2" style={{ background: 'orange', fontWeight: 'bold' }}>Late IN / Early Out</TableCell>
                                            {View.map((te, index) => <TableCell key={index} align="center">{te.LateInHours && te.LateInHours.toFixed(2) || ''}</TableCell>)}
                                            <TableCell align="center"></TableCell>
                                            <TableCell align="center"></TableCell>
                                            <TableCell align="center"></TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell align="center" colspan="2" style={{ background: 'red', fontWeight: 'bold', color: '#fff' }}>OT</TableCell>
                                            {View.map((fe, index) => <TableCell key={index} align="center">{fe.OTHours && fe.OTHours.toFixed(2) || ''}</TableCell>)}
                                            <TableCell align="center">{OTHours}</TableCell>
                                            <TableCell align="center">{otph && otph != null && otph.toFixed(2)}</TableCell>
                                            <TableCell align="center"></TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div> : null}
                    </div>
                </div>
            </div>
        );
    }
}


const mapStateToProps = state => {
    const subordinatesList = ([Object.assign({}, { label: `${state.auth.userObject.userName}-${state.auth.userObject.userID}(Self)`, value: state.auth.userObject.userID})]).concat(state.master.subordinatesListData);

    return {
        loggedUserDetail: state.auth.userObject,
        userPosInfo: state.auth.userPosInfo,
        userPref: state.auth.userPref,
        error: state.master.error,
        loading: state.master.loading,
        subordinatesList,
        employeeWorkSheetData: state.master.employeeWorkSheetData
    }
}


const mapDispatchToProps = dispatch => {
    return {
        fetchSubordinatesLists: (empId, compId) => dispatch(actions.fetchSubordinatesLists(empId, compId)),
        getEmployeeWorkSheetData: (data) => dispatch(actions.getEmployeeWorkSheetData(data)),
        clearCacheStorage: (type, data) => dispatch(actions.clearCacheStorage(type, data))
    }
}




export default connect(mapStateToProps, mapDispatchToProps)(ViewTimeSheet);